import React from 'react';
import { Box, Chip, Divider, Typography } from '@mui/material';

const RELEASES = [
  {
    version : 'v0.4.0',
    date    : 'November 2026',
    features: [
      'E-Mail-Posteingang mit IMAP-Integration',
      'Tabs: Posteingang, Erledigt, Gesendet, Alle',
      'Zuweisung von Verein, Mannschaft und Kontakt',
      'Interne Zuständig-Zuweisung an Organisatoren',
      'Junk-Erkennung: Spam-Header und konfigurierbare Absender-Blacklist',
      'Ausgehende eigene E-Mails automatisch als Gesendet markiert',
      'Vereins-Chip direkt in der E-Mail-Liste sichtbar',
      'Antwort-Funktion direkt aus dem Posteingang',
    ],
  },
  {
    version : 'v0.3.0',
    date    : 'Oktober 2026',
    features: [
      'Kostenübersicht mit Einzelposten für Frühstück, Abendessen und Biergarnituren',
      'Gesendete E-Mails beim Turnier-Abschluss automatisch archivieren',
      'Komplette Überarbeitung der Darstellung',
      'Telegram-Anbindung',
      'Verwaltung der Preisliste',    
    ],
  },
  {
    version : 'v0.2.0',
    date    : 'Oktober 2025',
    features: [
      'Einfacherer Zugriff auf die Datenbank',
      'Erste grundlegende UI Oberfläche',
      'Benutzerverwaltung hinzugefügt',
    ],
  },
  {
    version : 'v0.1.0',
    date    : 'Oktober 2023',
    features: [
      'Umbauen der bisherigen Verwaltung von Excel nach Django',
      'Aufbauen der Grund-API',
    ],
  },
];

export default function VersionInfo() {
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="h6" gutterBottom>Versionshistorie</Typography>
      {RELEASES.map((release, i) => (
        <Box key={release.version} sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
            <Chip label={release.version} color={i === 0 ? 'primary' : 'default'} />
            <Typography variant="body2" color="text.secondary">{release.date}</Typography>
          </Box>
          <Divider sx={{ mb: 1.5 }} />
          <Box component="ul" sx={{ m: 0, pl: 3 }}>
            {release.features.map(f => (
              <Typography key={f} component="li" variant="body2" sx={{ mb: 0.5 }}>
                {f}
              </Typography>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
